import { RootState } from "../../../store";
import { UserSlice } from "../../utils/types/common";

export const userRolesSelector = (state: RootState): UserSlice["roles"] => {
  return state.user.roles;
};
